import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import {
	ActionsProductMatches,
	failureProductMatches,
	loadGetProductMatches,
	loadProductMatchesSuccess,
} from "./actions";
import Env from "../../../consts/env";

function* loadDataProductMatches(params = {}) {

	try {

		yield put(loadGetProductMatches());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getProductMatches`;
		const headers = { ...Env.HEADERS, Authorization: params.Authorization, limit: params.limit };
		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(Env.REQUEST_TIMEOUT * 4),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureProductMatches(yield "Error Timeout.."));

		} else {

			const dataProductMatches = yield response.json();

			if (response.status !== 200) {

				yield put(failureProductMatches(yield response.statusText));

			} else {

				if (dataProductMatches.meta.code === 410) {

					window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/logout`;

				}

				yield put(loadProductMatchesSuccess(yield dataProductMatches));

			}

		}

	} catch (err) {

		yield put(failureProductMatches(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsProductMatches.GET_PRODUCT_MATCHES, loadDataProductMatches);

}
